import styles from './SiloTooltip.module.scss';

interface SiloTooltipProps {
    active?: boolean;
    payload?: Array<{ payload?: { currentPercent?: number; currentTons?: number } }>;
    label?: string | number;
}

const SiloTooltip = ({ active, payload, label }: SiloTooltipProps): JSX.Element | null => {
    if (active && payload && payload.length) {
        const data = payload[0]?.payload; // Zugriff auf die gesamte Datenzeile
        const percentValue = data?.currentPercent ?? 'N/A';
        const tonsValue = data?.currentTons ?? 'N/A';

        return (
            <div className={styles.tooltip}>
                <div className={styles.tooltipTextContainer}>
                    <div>
                        <b>Zeit:</b> {label !== undefined ? new Date(label).toLocaleString() : 'N/A'}
                    </div>
                    <div>
                        <b>Tonnen:</b> {tonsValue} t
                    </div>
                    <div>
                        <b>Prozent:</b> {percentValue} %
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default SiloTooltip;
